import ViewDataSinks from 'js/components/data_sinks/ViewDataSinks';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import UIUtils from 'js/lib/UIUtils';
import { TransformType } from 'new/components/ReusableTransform/types';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import React, { useEffect, useState } from 'react';
import CreateReusableTxFormContainer from './CreateReusableTxFormContainer';
import ViewReusableTransformsContainer from './ViewReusableTransformsContainer';
import { useDispatch, useSelector } from 'react-redux';
import { getCodeContainer } from 'js/actions';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_CODE_CONTAINER_REQUEST } from 'js/constants/actionTypes';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';

function ReusableTransformsDashboard(props) {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const loadingRecord = useIsLoading(GET_CODE_CONTAINER_REQUEST);
  const allDecoded = useSelector((state) => state.transforms.allTransforms.decoded);
  const [state, setState] = useState({
    formKey: 0,
    displayForm: false,
    transformBeingEdited: null,
    preSelectedTransformType: TransformType.ATTRIBUTE,
  });

  const transforms = useSelector((state) => state.entities.transforms);

  const params = new URLSearchParams(window.location.search);
  const editId = params.get('editId');
  const editType = params.get('editType');

  useEffect(() => {
    if (editId) {
      dispatch(getCodeContainer(editId));
    }
  }, [editId]);

  useDidUpdateEffect(() => {
    if (!loadingRecord && editId && !loaded) {
      const transformBeingEdited = Object.values(transforms).find((t) => t.id === Number(editId));
      const decodedInfo = allDecoded[transformBeingEdited?.id];
      // Adding decoded info to transform - doing that because when getting transforms from entity, they don't contains the decoded info
      const edited = {
        ...transformBeingEdited,
        ...decodedInfo,
        code: decodedInfo?.decoded,
      };
      if (transformBeingEdited && decodedInfo) {
        setLoaded(true);
        setState({
          displayForm: true,
          transformBeingEdited: edited,
          formKey: state.formKey + 1,
          preSelectedTransformType: editType,
        });
      }
    }
  }, [loadingRecord, editId, editType, allDecoded]);

  /**
   * @private
   * @param transformBeingEdited ReusableTransform || null
   * @param transformType        TransformType
   */
  function _handleFormLoadButtonClicked(
    transformBeingEdited = null,
    transformType = TransformType.ATTRIBUTE,
  ) {
    setState({
      displayForm: true,
      transformBeingEdited,
      formKey: state.formKey + 1,
      preSelectedTransformType: transformType,
    });
  }

  function _handleFormDismissed() {
    setState({ displayForm: false });
  }

  function _handleFormSubmitted() {
    setState({ displayForm: false });
  }

  const { withHeader, onlyTableView } = props;
  let transformId = UIUtils.extractParamFromURL(props.match);
  let displayContent;

  if (state.displayForm === true) {
    let isEditMode = state.transformBeingEdited !== null;

    displayContent = (
      <CreateReusableTxFormContainer
        key={state.formKey}
        isEditMode={isEditMode}
        preSelectedTransformType={state.preSelectedTransformType}
        transformBeingEdited={state.transformBeingEdited}
        onFormSubmitted={_handleFormSubmitted}
        onFormDismissed={_handleFormDismissed}
        onFormLoadButtonClicked={_handleFormLoadButtonClicked}
      />
    );
  } else {
    displayContent = (
      <ViewReusableTransformsContainer
        withHeader={withHeader}
        onlyTableView={onlyTableView}
        transformId={transformId}
        onFormLoadButtonClicked={_handleFormLoadButtonClicked}
      />
    );
  }
  return displayContent;
}

ViewDataSinks.defaultProps = {
  withHeader: true,
  onlyTableView: false,
};

export const reusableTransformsDashboardScreenConfig = {
  screenName: 'ReusableTransformsDashboard',
  domain: 'integrate',
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_REUSABLE_TRANSFORMS}`,
  exact: true,
  pageTitle: 'Transforms',
  defaultProps: {
    withHeader: false,
    onlyTableView: true,
  },
};

ReusableTransformsDashboard.screenConfig = reusableTransformsDashboardScreenConfig;

export default ReusableTransformsDashboard;
